export default __webpack_public_path__ + "static/media/may2024-2.53c121c3.jpg";